import React from 'react';
import './profile-briefs.scss';

import { Text, Link } from '@ui-kit';
import LinkIcon from '@ui-kit/icons/external-link-white.svg';

const OpportunItem = ({ item = {} }) => {
  const {title, url, description, theme, rank} = item;

  return (
    <div className="opp-table-row">
      <div className="rank">
          <Text as="h5">#{rank || ''}</Text>
      </div>
      <div className="title">
        <Text as="h5">{title || ''}</Text>
        <Text as="h6">{theme || ''}</Text>
      </div>
      <div className="description">
        <Text as="h6">{description || ''}</Text>
      </div>

      <div className="create">
          <Link 
            size="sm" 
            icon={LinkIcon}
            to={url}
            target="_blank"
          >
            <Text as="span">Create</Text>
          </Link>
      </div>
    </div>
  );
};

export default OpportunItem;
